import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { networkingSelector, isSummaryActiveStep } from '../selectors/wizardSelectors';
import { updateStep } from '../actions/wizardActions';
import Networking from '../components/Networking/Networking';

const mapStateToProps = createStructuredSelector({
    editable: isSummaryActiveStep,
    formData: networkingSelector
});

const mapDispatchToProps = { updateStep };

export default withTranslation(['common', 'validations', 'wizard'])(
    connect(mapStateToProps, mapDispatchToProps)(Networking)
);
